import React from 'react';

const ModalConfirmImg = ({ callBackConfirmAction }) => {
    // 심플 이미지 > 이미지 카드
    const confirmAction = e => {
        const action = e.target.dataset.action;
        callBackConfirmAction(action);
    };

    return (
        <div className="dialog-confirm">
            <h4>응답 설정 변경</h4>
            <p>
                이미지를 케로셀로 변경할 경우
                <br />
                모든 이미지 비율이 2:1로 변경됩니다.
                <br />
                정사각형 이미지는 카드를 이용해주세요.
                <br />
                <br />
                <strong>설정을 변경하시겠습니까?</strong>
            </p>
            <div>
                <button
                    type="button"
                    onClick={confirmAction}
                    data-action="submit"
                >
                    확인
                </button>
                <button
                    type="button"
                    onClick={confirmAction}
                    data-action="cancel"
                >
                    취소
                </button>
            </div>
        </div>
    );
};

ModalConfirmImg.defaultProps = {
    // bla: 'test',
};

export default ModalConfirmImg;
